export default __webpack_public_path__ + "static/media/pickup.cccc6672.svg";